import { isValidElement } from 'react';

import { ErrorBoundary } from '@/shared/components/ErrorBoundary';

const BasketErrorBoundary = ErrorBoundary(({ children }, error?: Error) => {
  if (error) {
    console.warn('Basket error: ', error.message);

    if (isValidElement(children)) {
      console.warn('Basket props: ', children.props);
    }
    return null;
  }
  return children;
});

export default BasketErrorBoundary;
